export default {
  title: 'Bankoplysninger',
  buttons: {
    save: 'Gem',
  },
  toasts: {
    success: 'Dine oplysninger er gemt.',
  },
};
